import { Component } from "react";
import { isNotEmpty } from "../../utils";

type OwnProps = {
  id: string;
  text?: string;
  name?: string;
  initial?: boolean;
  values?: $TSFixMe;
};

type State = $TSFixMe;

const defaultProps: Partial<OwnProps> = {
  initial: false,
};

type Props = OwnProps & typeof defaultProps;

class ToggleLabel extends Component<Props, State> {
  static readonly defaultProps = defaultProps;

  render() {
    const { id, name, text, initial, values } = this.props;
    const displayText = isNotEmpty(text) ? text : "Unknown";

    // @ts-expect-error TS(2538) FIXME: Type 'undefined' cannot be used as an index type.
    const initialState = values ? values[name] : initial;
    // @ts-expect-error TS(2538) FIXME: Type 'undefined' cannot be used as an index type.
    this.state = { isToggleOn: values ? values[name] : false };

    const toggleStyle = initialState ? "btn-toggle-on" : "btn-toggle-off";
    const className = `btn-toggle ${toggleStyle}`;
    const result = (
      // @ts-expect-error TS(2322) FIXME: Type '{ children: Element; id: string; name: strin... Remove this comment to see the full error message
      <div id={id} name={name} className={className}>
        <span>{displayText}</span>
      </div>
    );

    return <div>{result}</div>;
  }
}

export default ToggleLabel;
